export default __webpack_public_path__ + "static/fav-icon-eeef63c1296e3b28c12c1e1b7dc64559.png";